module.exports = __webpack_public_path__ + "static/media/finger@3x.6f03e49a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/tutorial/finger@3x.png
// module id = 270
// module chunks = 0